export default __webpack_public_path__ + "static/media/ZeroButtonClicked.ee79258b.svg";